import { GlobalState } from "src/reducers";

export const selectPublicScreenshots = (state: GlobalState) =>
    state.publicBuys.screenshots;

export const selectPublicBuys = (state: GlobalState) => state.publicBuys.buys;
